"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnlineCart = void 0;
const react_1 = require("react");
const providers_1 = require("../providers");
const reducers_1 = require("../reducers");
const cartService = __importStar(require("../services/cart.service"));
const utils_1 = require("../utils");
const onError = (dispatch) => {
    return (error) => {
        dispatch((0, reducers_1.actionSetCartWithError)());
        throw error;
    };
};
/**
 * Hook to manage the online cart state, don't use this hook to use cart, use {@link useCart} instead
 */
function useOnlineCart() {
    var _a;
    const context = (0, react_1.useContext)(providers_1.CartContext);
    if (context === undefined) {
        throw new Error('useOnlineCart must be used within a OnlineCartProvider or CartProvider');
    }
    const { state, dispatch } = context;
    const cartId = (_a = state.cart) === null || _a === void 0 ? void 0 : _a.id;
    const loadCart = () => __awaiter(this, void 0, void 0, function* () {
        dispatch((0, reducers_1.actionSetCartIsLoading)());
        try {
            const cartData = (0, utils_1.getCartFromLocalStorage)();
            if (!cartData || !cartData.id) {
                throw new Error('Cart not found');
            }
            return cartService.getCart(cartData.id).then((cart) => {
                dispatch((0, reducers_1.actionSetCartData)(cart));
                dispatch((0, reducers_1.actionSetCartItems)((0, utils_1.mapCartItemsFromCartResponse)(cart)));
                dispatch((0, reducers_1.actionSetCartStrategy)('online'));
                dispatch((0, reducers_1.actionSetCartIsLoaded)());
            });
        }
        catch (error) {
            onError(dispatch)(error);
        }
    });
    const createCart = (params) => {
        dispatch((0, reducers_1.actionSetCartIsLoading)());
        return cartService
            .createCart({
            customer: params.customer,
            catalogSlug: params.catalogSlug,
            state: params.state,
            cycle: Number(params.cycle),
            businessUnit: params.businessUnit,
        })
            .then((cart) => {
            dispatch((0, reducers_1.actionSetCartData)(cart));
            dispatch((0, reducers_1.actionSetCartItems)([]));
            dispatch((0, reducers_1.actionSetCartStrategy)('online'));
            dispatch((0, reducers_1.actionSetCartIsLoaded)());
        })
            .catch(onError(dispatch));
    };
    const addItem = (productItem, businessUnit) => {
        dispatch((0, reducers_1.actionSetCartIsLoading)());
        return cartService
            .updateItem(cartId, productItem.sku, {
            quantity: utils_1.DEFAULT_INCREMENT_CART_QUANTITY,
        })
            .then(() => {
            dispatch((0, reducers_1.actionAddCartItem)((0, utils_1.mapCartItemFromProduct)(productItem, businessUnit)));
            dispatch((0, reducers_1.actionSetCartIsLoaded)());
        })
            .catch(onError(dispatch));
    };
    const removeItem = (item) => {
        dispatch((0, reducers_1.actionSetCartIsLoading)());
        return cartService
            .deleteItem(cartId, item.id)
            .then(() => {
            dispatch((0, reducers_1.actionRemoveCartItem)(item));
            dispatch((0, reducers_1.actionSetCartIsLoaded)());
        })
            .catch(onError(dispatch));
    };
    const updateItemQuantity = (item) => {
        dispatch((0, reducers_1.actionSetCartIsLoading)());
        return cartService
            .updateItem(cartId, item.id, {
            quantity: item.quantity,
        })
            .then(() => {
            dispatch((0, reducers_1.actionUpdateItemQuantity)(item));
            dispatch((0, reducers_1.actionSetCartIsLoaded)());
        })
            .catch(onError(dispatch));
    };
    const clearCart = () => {
        dispatch((0, reducers_1.actionClearCart)());
    };
    const assignCustomerToCart = (customer) => __awaiter(this, void 0, void 0, function* () {
        dispatch((0, reducers_1.actionSetCartIsLoading)());
        return cartService
            .updateCart(cartId, { customer })
            .then((data) => {
            dispatch((0, reducers_1.actionSetCartData)(data));
            dispatch((0, reducers_1.actionSetCartIsLoaded)());
        })
            .catch(onError(dispatch));
    });
    return {
        loadCart,
        createCart,
        addItem,
        removeItem,
        updateItemQuantity,
        assignCustomerToCart,
        clearCart,
    };
}
exports.useOnlineCart = useOnlineCart;
